import { Users } from '@prisma/client';

export type User = {
  id: string;
  name: string;
  firstName: string;
  photoUrl: string | null;
  role: string | null;
  locale: string | null;
  isMe: boolean;
  custom: { [key: string]: string };
};

export type Message = {
  attachment: {
    dimensions: { height: number; width: number };
    size: number;
    url: string;
  } | null;
  conversationId: string;
  createdAt: number;
  custom: Record<string, string>;
  editedAt: number | null;
  id: string;
  location: [number, number] | null;
  origin: string;
  readBy: string[];
  referencedMessageId: string | null;
  senderId: string;
  text: string;
  type: string;
};

export type Reaction = {
  emoji: string;
  iReacted: boolean; // Whether the current user has placed this rreaction
  numReactions: number; // the number of users who reacted with this emoji
};

export type File = {
  url: string;
  filename: string;
  formattedFilename?: unknown;
  // The file's size in bytes
  size: number;
  // For images or videos, to show thumbnails at the correct size before loading to prevent content shift on slow connections
  dimensions?: { width: number; height: number } | null;
  type: 'image' | 'video' | 'audio' | 'other';
};

export type Conversation = {
  id: string;
  rawSubject: string | null;
  formattedSubject: unknown;
  photoUrl: string | null;
  custom: { [key: string]: string };
  participants: Record<
    string,
    {
      access: 'ReadWrite';
      notify: boolean;
    }
  >;
  // Participants in the conversation, excluding the current user
  otherParticipants: User[];
  isGroupChat: boolean; // true if this conversation has more than 2 participants or if it has no participants (meaning everyone is a guest)
};

export type UserConversation = {
  id: string;
  subject: string | null;
  photoUrl: string | null;
  welcomeMessages: string[] | null;
  custom: { [name: string]: string };
  lastMessage: Message | null;
  unreadMessageCount?: number;
  isUnread?: boolean;
  participants: (Pick<Users, 'userId' | 'firstName' | 'lastName' | 'role'> & {
    participantId: string;
    notify: boolean;
    isUnread: boolean;
  })[];
  createdAt: number;
  lastMessageAt: number | null;
};

export type UnreadConversation = {
  id: string;
  participants: Record<string, User>;
  custom: Record<string, string>;
  subject: string | null;
  isUnread: boolean;
  unreadMessageCount: number;
  createdAt: number;
  topicId: string | null;
  photoUrl: string | null;
  welcomeMessages: string | null;
};

export type ConversationsPage = {
  result: Array<UserConversation>;
  meta: {
    hasMore: boolean;
    cursor: number | null;
  };
};

export enum ChatFilter {
  ALL = 'ALL',
  UNREADS = 'UNREADS',
  UNANSWERED = 'UNANSWERED',
  ARCHIVED = 'ARCHIVED',
}
